import Wizzard from './components/Wizzard'

const MainPage = () => {
    return <Wizzard />
}

export default MainPage
